import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueLazyload from 'vue-lazyload'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

Vue.use(VueLazyload, {
  preLoad: 1.5,  //图片预加载高度
  error: require('./assets/index/logo.png'),  //加载错误
  loading: require('./assets/loading.gif'), //加载图片中
  attempt: 1 //允许加载错误次数
})

Vue.use(VueAwesomeSwiper)

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})

router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) { 
    from.name ? next({
      name: from.name
    }) : next('/'); 
  } else {
    next(); //如果匹配到正确跳转
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
